/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * WorkOS Directory Sync attributes for an identity. Every field is mapped by the customer's IdP: scalar attributes are absent when unset or blank, and 'groups' is always present, empty when the identity belongs to none.
 */
export type IdentityDirectory = {
  /**
   * The directory cost centre.
   */
  costCenterName?: string | undefined;
  /**
   * The directory department.
   */
  departmentName?: string | undefined;
  /**
   * The directory division.
   */
  divisionName?: string | undefined;
  /**
   * The directory employment type.
   */
  employeeType?: string | undefined;
  /**
   * The directory groups the identity currently belongs to.
   */
  groups: Array<string>;
  /**
   * The directory job title.
   */
  jobTitle?: string | undefined;
};

/** @internal */
export const IdentityDirectory$inboundSchema: z.ZodMiniType<
  IdentityDirectory,
  unknown
> = z.pipe(
  z.object({
    cost_center_name: z.optional(z.string()),
    department_name: z.optional(z.string()),
    division_name: z.optional(z.string()),
    employee_type: z.optional(z.string()),
    groups: z.array(z.string()),
    job_title: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "cost_center_name": "costCenterName",
      "department_name": "departmentName",
      "division_name": "divisionName",
      "employee_type": "employeeType",
      "job_title": "jobTitle",
    });
  }),
);

export function identityDirectoryFromJSON(
  jsonString: string,
): SafeParseResult<IdentityDirectory, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IdentityDirectory$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IdentityDirectory' from JSON`,
  );
}
